function loadReviewsIO() {
  let reviewsIOObserver;

  function loadCSS(href) {
    return new Promise((resolve, reject) => {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = href;
      link.onload = () => resolve();
      link.onerror = () => reject(new Error(`Failed to load CSS: ${href}`));
      document.head.appendChild(link);
    });
  }

  function loadScript(src) {
    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = src;
      script.onload = () => resolve();
      script.onerror = () => reject(new Error(`Failed to load script: ${src}`));
      document.head.appendChild(script);
    });
  }

  function initializeRatingSnippet() {
    try {
      if (typeof ratingSnippet === 'function') {
        const themeVariant =
          window.settings?.theme_variant ||
          document.querySelector('[data-theme-variant]')?.dataset.themeVariant ||
          'mackenzie';

        const storeName = themeVariant === 'mackenzie' ? 'mackenzie-ltd.' : 'chesapeake-crab-cakes';

        ratingSnippet('ruk_rating_snippet', {
          store: storeName,
          color: '#f47e27',
          linebreak: true,
          text: 'Reviews',
        });
      }
    } catch (error) {
      //
    }
  }

  function setupReviewsIOObserver() {
    const targetContainer = document.querySelector('.kuSearchResultsPageContainer');

    if (!targetContainer) {
      setTimeout(setupReviewsIOObserver, 5000);
      return;
    }

    if (reviewsIOObserver) {
      reviewsIOObserver.disconnect();
    }

    reviewsIOObserver = new MutationObserver(function (mutations) {
      let shouldReinitializeReviews = false;

      mutations.forEach(function (mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          shouldReinitializeReviews = true;
        }
      });

      if (shouldReinitializeReviews) {
        clearTimeout(window.reviewsReinitTimeout);
        window.reviewsReinitTimeout = setTimeout(function () {
          initializeRatingSnippet();
        }, 300);
      }
    });

    reviewsIOObserver.observe(targetContainer, {
      attributes: true,
      attributeFilter: ['class'],
      subtree: true,
    });
  }

  Promise.all([
    loadCSS('https://widget.reviews.io/rating-snippet/dist.css'),
    loadScript('https://widget.reviews.io/product/dist.js'),
    loadScript('https://widget.reviews.io/rating-snippet/dist.js'),
  ])
    .then(() => {
      setTimeout(() => {
        initializeRatingSnippet();
        setupReviewsIOObserver();
      }, 500);
    })
    .catch((error) => {
      //
    });
}

window.loadReviewsIO = loadReviewsIO;

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', loadReviewsIO);
} else {
  loadReviewsIO();
}
